import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { dateSessionStorageFormat } from '../../../app/buyflow-home/buyflow-home.component';
import { Observable } from 'rxjs/internal/Observable';
import {
  BuyflowProductOffering,
  LineItem,
} from 'anchor-shared/lib/model/interface/buyflowProductOffering';
import { Moment } from 'moment';
import { CharterVesselAvailabilityDAO } from '../dao/charterVesselAvailabilityDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { RoundDownPipe } from '../../../app/shared/pipes/roundDown.pipe';
import { VesselRateCalculationService } from '../vessel-rate-calculation-service';
import { Subscription } from 'rxjs';

@Injectable()
export class CharterBuyflowHelperService {
  subs: Subscription[] = [];
  constructor(
    private charterVesselAvailabilityDAO: CharterVesselAvailabilityDAO,
    private roundDownPipe: RoundDownPipe,
    private calcService: VesselRateCalculationService,
  ) {}

  getAvailableProductsForDay(
    isBrowser: boolean,
    availableOn: Moment,
    vessel: Vessel,
  ): Observable<BuyflowCharterInformation> {
    return new Observable<BuyflowCharterInformation>((observer) => {
      let selectedProduct = null;
      let currentPrice = null;
      let listPrice = null;

      if (isBrowser) {
        if (sessionStorage.getItem('filterDate')) {
          availableOn = moment(
            sessionStorage.getItem('filterDate'),
            dateSessionStorageFormat,
          )
            .utc()
            .startOf('day');
        } else {
          availableOn = null;
        }

        const productSub = this.charterVesselAvailabilityDAO
          .getAvailableProductsForDay(vessel.id, availableOn)
          .subscribe((productValues) => {
            const productsOffered = productValues;

            if (productsOffered && productsOffered.length) {
              productsOffered.forEach((product) => {
                if (product.duration === 4 || !selectedProduct) {
                  selectedProduct = product;
                }
              });
              currentPrice = this.filterLineItemPrice(
                selectedProduct.lineItems,
              );
              listPrice = `$${this.roundDownPipe
                .transform(currentPrice)
                .toString()}`;
            } else {
              selectedProduct = null;
              listPrice = `$${this.roundDownPipe
                .transform(vessel.halfDayListPrice)
                .toString()}`;
            }
            observer.next({
              productsOffered: productsOffered,
              selectedProduct: selectedProduct,
              listPrice: listPrice,
            });
            observer.complete();
          });
        this.subs.push(productSub);
      } else {
        observer.next(null);
        observer.complete();
      }
    });
  }

  private filterLineItemPrice(lineItem: LineItem[]): number {
    const filteredBCCLineItems = lineItem.filter((item) => {
      return (
        item.lineItemName === 'Owner' ||
        item.lineItemName === 'Captain' ||
        item.lineItemName === 'Crew'
      );
    });
    const originalTotal =
      this.calcService.getBoatCaptainCrewLineItemsOriginalTotal(
        filteredBCCLineItems,
      );
    return this.calcService.getBoatCaptainCrewLineItemsTotal(
      filteredBCCLineItems,
    );
  }
}

export interface BuyflowCharterInformation {
  productsOffered: BuyflowProductOffering[];
  selectedProduct: BuyflowProductOffering;
  listPrice: string;
}

export function sortTimes(timeArray: string[]): string[] {
  return timeArray.sort((a, b) => {
    return moment(a, 'h:mm A').unix() - moment(b, 'h:mm A').unix();
  });
}
